var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLogoEng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 429,
    height: 129,
    viewBox: "0 0 429 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6 91.69V33H0.879997V91.69H16.6ZM99.5 91.69V33H85.5L67.61 62.68H67.43L49.47 33H35.1V91.69H50.46V63.48H50.9L64.29 85.31H69.86L83.24 63.48H83.69V91.69H99.5ZM154.37 55.49H133.72V46.24H168.12V33H118V91.69H170.09V78.48H133.72V68.16H154.37V55.49ZM210.51 91.69C222.09 91.69 229.51 88.36 234.58 83.34C239.97 78.03 242.84 70.49 242.84 62.34C242.978 54.7495 240.168 47.4012 235 41.84C229.52 36.09 221.44 33.04 210.48 33.04H183.48V91.69H210.51ZM199.19 78.48V46.24H210.19C216.66 46.24 219.71 47.86 222.31 50.64C225.1 53.64 226.62 57.38 226.62 62.5C226.62 67.97 224.92 71.66 221.86 74.62C219.26 77.14 216.21 78.48 210.19 78.48H199.19ZM272.66 91.69V33H256.94V91.69H272.66Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.86 34.94V87.63H388.66V75.77H359V34.94H344.86ZM364.49 1.75876e-05C379.381 -0.00432927 393.813 5.15496 405.326 14.5987C416.839 24.0424 424.721 37.1863 427.629 51.7904C430.538 66.3945 428.292 81.5552 421.275 94.689C414.257 107.823 402.903 118.117 389.147 123.817C375.39 129.518 360.082 130.272 345.832 125.951C331.582 121.629 319.271 112.501 310.998 100.12C302.724 87.7391 298.999 72.8724 300.459 58.0532C301.918 43.234 308.47 29.3793 319 18.85C324.969 12.869 332.06 8.12507 339.866 4.89036C347.672 1.65565 356.04 -0.00623674 364.49 1.75876e-05Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogoEng);
export default __webpack_public_path__ + "static/media/whiteLogo_Eng.478a5bc344b1f9de63eb7a51a6b25de6.svg";
export { ForwardRef as ReactComponent };